import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Credential Requests|Remove Change Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryRemoveChangeModal';
export type SPCandidateHistoryRemoveChangeModalLocNames =
	| `${LocNameStart}TitleModal`
	| `${LocNameStart}ContentActiveOption`
	| `${LocNameStart}ContentInstructions`
	| `${LocNameStart}LabelCredential`
	| `${LocNameStart}ErrorCredentialRequired`
	| `${LocNameStart}ErrorCredentialNoMatch`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}ErrorCommentsRequired`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonContinue`;

export const spCandidateHistoryRemoveChangeModalLocs: LocDefs<SPCandidateHistoryRemoveChangeModalLocNames> =
	{
		SPCandidateHistoryRemoveChangeModalTitleModal: {
			defaultValue: 'Remove Manual Change',
			description: 'Modal Title',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			legacyName: 'Credential/RemoveChangeModal.Title.RemoveManualChange',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalContentActiveOption: {
			defaultValue: 'Active:',
			description: 'Active Option',
			displayPath: `${pathStart}Active`,
			displayType: 'Content',
			legacyName: 'Credential/RemoveChangeModal.Content.ActiveOption',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalContentInstructions: {
			defaultValue:
				'Select the manual change to remove, and enter a comment. The system will rebuild the candidate, omitting that change.',
			description: 'Instructions content',
			displayPath: `${pathStart}Instructions`,
			displayType: 'Content',
			legacyName: 'Credential/RemoveChangeModal.Content.Instructions',
			htmlAllowed: true,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalLabelCredential: {
			defaultValue: 'Credential',
			description: 'Label for credential field',
			displayPath: `${pathStart}Credential`,
			displayType: 'Label',
			legacyName: 'Credential/RemoveChangeModal.FieldLabel.Credential',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalErrorCredentialRequired: {
			defaultValue: 'This field is required',
			description: 'Error message for required credential field',
			displayPath: `${pathStart}Credential Required`,
			displayType: 'Error',
			legacyName: 'Credential/RemoveChangeModal.FieldError.CredentialRequired',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalErrorCredentialNoMatch: {
			defaultValue: 'You must choose an option from the list',
			description: 'Error message for no match in credential field',
			displayPath: `${pathStart}Credential No Match`,
			displayType: 'Error',
			legacyName: 'Credential/RemoveChangeModal.FieldError.CredentialNoMatch',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalLabelComments: {
			defaultValue: 'Comments',
			description: 'Label for comments field',
			displayPath: `${pathStart}Comments`,
			displayType: 'Label',
			legacyName: 'Credential/RemoveChangeModal.FieldLabel.Comments',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalErrorCommentsRequired: {
			defaultValue: 'This field is required',
			description: 'Error message for required comments field',
			displayPath: `${pathStart}Comments Required`,
			displayType: 'Error',
			legacyName: 'Credential/RemoveChangeModal.FieldError.CommentsRequired',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button text',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Credential/RemoveChange.Modal.Button.Cancel',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRemoveChangeModalButtonContinue: {
			defaultValue: 'Continue',
			description: 'Continue button text',
			displayPath: `${pathStart}Continue`,
			displayType: 'Button',
			legacyName: 'Credential/RemoveChange.Modal.Button.Continue',
			htmlAllowed: false,
			...sharedProperties,
		},
	};

export type SPCandidateHistoryRemoveChangeModalLocType =
	LocMap<SPCandidateHistoryRemoveChangeModalLocNames>;
